<template>
  <div class="image-share-list-container">
    <ul class="image-share-list">
      <li class="image-share-item">
        <a @click="handleDownload" href="#" class="image-share-link">
          <span class="iconfont"> 点击下载【{{ btnTitle }}】到本地 </span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ImageShareList',
  props: {
    btnTitle: {
      type: String,
      default: '分享'
    }
  },
  methods: {
    handleDownload() {
      this.$emit('download')
    }
  }
}
</script>

<style scoped>
.image-share-list-container {
  display: block;
  width: 100%;
  text-align: right;
}

.image-share-list {
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 8px;
}

.image-share-item {
  list-style: none;
  margin: 0 25px;
}

.image-share-link span {
  color: #333;
  letter-spacing: 1px;
  transition: 0.5s;
  font-size: 15px;
  font-weight: 500;
  padding: 0 20px;
}

.image-share-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  height: 60px;
  background: #fff;
  position: relative;
  transition: 0.5s;
  font-size: 15px;
  border: 1px solid #e6f5de;
  border-radius: 4px;
}

.image-share-link::before {
  content: "";
  position: absolute;
  top: 8px;
  left: -16px;
  height: 100%;
  width: 16px;
  background-color: #cecece;
  transition: 0.5s;
  transform: skewY(-45deg);
}

.image-share-link::after {
  content: "";
  position: absolute;
  bottom: -16px;
  left: -8px;
  height: 16px;
  width: 100%;
  background-color: #cecece;
  transition: 0.5s;
  transform: skewX(-45deg);
}

.image-share-item:hover {
  color: #fff;
}

.image-share-item:hover span {
  color: #fff;
}

.image-share-item:hover .image-share-link {
  background-color: #67c23a;
  transform: translate(8px, -8px);
  box-shadow: -15px 15px 25px rgba(0, 0, 0, 0.3);
}

.image-share-item:hover .image-share-link::before {
  background-color: #377319;
}

.image-share-item:hover .image-share-link::after {
  background-color: #377319;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding-right: 10px;
}
</style>
